import SEO from '../../seo'

const AppFavicons = () => {
    return (
        <SEO
            title="Install Startpage App"
            description="Search without tracking or profiling on Startpage."
            ogImagePath="https://www.startpage.com/sp/cdn/images/startpage-app-favicon.png"
            favicons={[
                {
                    rel: `icon`,
                    type: `image/x-icon`,
                    sizes: `16x16`,
                    href: `https://www.startpage.com/sp/cdn/images/app-promo/favicon.ico`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `16x16`,
                    href: `https://www.startpage.com/sp/cdn/images/app-promo/favicon-16x16.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `32x32`,
                    href: `https://www.startpage.com/sp/cdn/images/app-promo/favicon-32x32.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `192x192`,
                    href: `https://www.startpage.com/sp/cdn/images/app-promo/android-chrome-192x192.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `512x512`,
                    href: `https://www.startpage.com/sp/cdn/images/app-promo/android-chrome-512x512.png`,
                },
                {
                    rel: 'apple-touch-icon',
                    type: `image/png`,
                    sizes: `180x180`,
                    href: `https://www.startpage.com/sp/cdn/images/app-promo/apple-touch-icon.png`,
                },
            ]}
        />
    )
}
export default AppFavicons
